// Deliberate UI problems, left in so Prism has something real to catch in the demo. Prism should show each one
// on its AI Insights page and in Heads up:
//   - Add Note: Author is required but starts blank, and its "Use my name" button does nothing
//   - Add Appointment: Status is required but has no default
// Build with REACT_APP_DEMO_UI_ISSUES=off to ship the fix (Author filled in, Status "scheduled", the button works).
export const DEMO_AUTHOR = "Demo User";

export function demoUiIssuesOn(setting = process.env.REACT_APP_DEMO_UI_ISSUES) {
  return setting !== "off";
}

export const DEMO_UI_ISSUES = demoUiIssuesOn();

// What a new Note or Appointment form starts with
export function newFormData(formType, issuesOn = DEMO_UI_ISSUES) {
  if (issuesOn) return {};
  if (formType === "Note") return { author: DEMO_AUTHOR };
  if (formType === "Appointment") return { status: "scheduled" };
  return {};
}
